import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';

export const CoverageWrapper = createWrapper('Coverage', () => ({}));
export type WrappedCoverage = ReturnType<typeof CoverageWrapper>;